$(document).ready(function () {
    $("#geolocation").click(function () {
        if( !$(this).hasClass('clicked') ) {
            $(this).addClass('clicked');
            getLocation();
            $('#geolocation i').hide();
            $('#geolocation').append("<img class='loader' src='" + assetPath + "/assets/img/loader.gif'>");
        }
    });

    $('form[name=searchBox]').submit(function (e) {
        var input = $('form[name=searchBox] input[name=search]');
        if( !$(input).val() ) {
            $(input).addClass('invalid');
            return false;
        } else {
            $(input).removeClass('invalid');
            return true;
        }
    })
});


function getLocation() {
    navigator.geolocation.watchPosition(
        function(position) {
            var lat = position.coords.latitude;
            var long = position.coords.longitude;

            var getUrl = window.location;
            var baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + 'store-locator'/*getUrl.pathname.split('/')[1]*/;

            var point = new google.maps.LatLng(lat, long);

            new google.maps.Geocoder().geocode({'location': point}, function (res, status) {
                var zip = res[0].formatted_address.replace(/, |,/g, "+");
                window.location = baseUrl + "?search=" + zip;
            });
            console.log('lat: '+lat+', long: '+long);
        },
        function (error) {
            if (error.code == error.PERMISSION_DENIED) {
                $('#geolocation .loader').remove();
                $('#geolocation i').show();
                alert("Error getting your location, please search manually.");
            }
        }
    );
}
